// import React, { useContext, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
// import { UserContext } from "../../../context/UserContext";
import DoctorLayout from "../../Layout/DoctorLayout";
import PatientsIP from "../../PatientsIP/PatientsIP";
import DoctorAppointments from "../../DoctorView/Appointments/DoctorAppointments";
import PatientCards from "../../DoctorView/PatientCards";
import PatientTypeContextProvider from "../../Layout/DoctorLayout/PatientTypeContextProvider";
import FacilityDietChart from "../FacilityDiet/FacilityDietChart";
import ExercisePage from "../../OpEMR/Physiotherapist/Forms/OpFormComponents/ExerciseComponents/ExericsePage";

const CommonView = () => {
  const location = useLocation();
  const query = useParams();
  const params = Object.fromEntries(new URLSearchParams(location?.search));
  const isDoctor = location?.pathname?.startsWith("/doctor");
  // const { userDetails } = useContext(UserContext);

  // useEffect(() => {
  //   if (userDetails?.currFacility) {
  //     console.log(userDetails?.currFacility === 1 ? "Hello" : "Hai");
  //   }
  // }, [userDetails?.currFacility]);

  return (
    <PatientTypeContextProvider>
      {query?.tab === "appointments" ? (
        <DoctorAppointments />
      ) : query?.tab === "diet-chart" ? (

        <DoctorLayout header={true} showNotifications={true}>
          <FacilityDietChart />
        </DoctorLayout>
        ) : query?.tab === "exercise" ? (    
      <DoctorLayout header={true} showNotifications={true}>
        <ExercisePage />
      </DoctorLayout>
    ) : (
        <PatientTypeContextProvider>
          {params?.patient ? (
            <DoctorLayout showPatientSegment={true}>
              <PatientsIP />
            </DoctorLayout>
          ) : (
            <DoctorLayout
              showPatientSegment={true}
              header={true}
              showNotifications={isDoctor}
              lockPageScroll
            >
              <PatientCards />
            </DoctorLayout>
          )}
        </PatientTypeContextProvider>
      )}
    </PatientTypeContextProvider>
  );
};

export default CommonView;
